function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "menu_home");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "menu_home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/home-copy-7"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "0122_home",
  transform: "translate(0.000000, -0.500000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1776224,9.40184369 C21.5207283,9.40184369 21.5207283,7.74072937 21.5207283,13.209048 L21.5207283,21.1812842 L16.1580832,21.1812842 L16.1580832,15.1421655 C16.1580832,14.7780081 15.8639857,14.4828076 15.5011891,14.4828076 L9.76829459,14.4828076 C9.40549792,14.4828076 9.11140044,14.7780081 9.11140044,15.1421655 L9.11140044,21.1812842 L3.72486834,21.1812842 L3.72486834,8.63260082 L4.3544357,8.26395982 L12.6227983,3.42266653 L23.5120115,9.94232534 C23.8254098,10.1258426 24.2276201,10.0195781 24.4104039,9.70502843 C24.5932115,9.39047876 24.487368,8.98673594 24.1739936,8.80326661 L12.9537774,2.08980454 C12.7492564,1.97006515 12.4963402,1.97006515 12.2917953,2.08980454 L3.6924536,7.1249011 L0.826006368,8.80326661 C0.512632024,8.98673594 0.40678846,9.39047876 0.589596132,9.70502843 C0.711682897,9.91513582 0.931611061,10.0322618 1.15763043,10.0322618 C1.26999516,10.0322618 1.38393643,10.00325 1.48801236,9.94232534 L2.41110391,9.40184369 L2.41110391,21.8406421 C2.41110391,22.2047995 2.7052014,22.5 3.06799807,22.5 L9.76831848,22.5 C10.1311152,22.5 10.4252126,22.2047995 10.4252126,21.8406421 L10.4252126,15.8015233 L14.8443188,15.8015233 L14.8443188,21.8401626 C14.8443188,21.8403304 14.8443188,21.8404983 14.8443188,21.8406421 C14.8443188,22.2047995 15.1384163,22.5 15.5012129,22.5 L22.1776224,22.5 C22.5404191,22.5 22.8345166,22.2047995 22.8345166,21.8406421 L22.8345166,10.0612016 C22.8345166,9.69704421 22.8345166,9.40184369 22.1776224,9.40184369 Z",
  id: "Path-Copy-80",
  stroke: "#2D32AA",
  strokeWidth: 0.7425,
  fill: "#2D32AA",
  fillRule: "nonzero"
}))));

var SvgMenuHome = function SvgMenuHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu_home.a4bffa9a.svg";
export { ForwardRef as ReactComponent };